import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-person-dossier-tabs',
  templateUrl: './person-dossier-tabs.component.html'
})

export class PersonDossierTabsComponent {
  @Input() selectedEntityId: String;
  @Input() selectedEntityType: String;
}



// WEBPACK FOOTER //
// ./src/app/entities/person-dossier-tabs.component.ts